import { Box, Typography } from "@mui/material"
import { CustomPaper } from "../CustomPaper"
import { useStyles } from "./styles"
import { QuestionnaireProps } from "./types"
import { useTranslation } from "react-i18next"

const HeaderQuestionnaire = ({ title, question, answerList, parentId, version }: QuestionnaireProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    return (
        <CustomPaper sx={styles.container}>
            <Box sx={styles.version}>
                <Typography variant="subtitle" fontWeight='bold'>{title ?? ''}</Typography>

                {(!!parentId || !!version) && <Typography variant="footer" fontWeight='500'>#{parentId} - {t('general.tags.version')}: {version}</Typography>}
            </Box>

            <Typography variant="subtitle_grey"><span className="font-bold">Pregunta:</span> {question ?? ''}</Typography>

            {
                answerList?.map(answer => <Typography variant="subtitle_grey"><span className="font-bold">Item:</span> {answer.label ?? ''}</Typography>)
            }
        </CustomPaper>
    )
}

export { HeaderQuestionnaire }